export const PROFILE_DUCK = 'profile'

export const PROFILE_UPDATE_PROFILE_STATUS = 'profile/updateProfileStatus'
export const PROFILE_UPDATE_PASSWORD_STATUS = 'profile/updatePasswordStatus'
export const PROFILE_UPDATE_PROFILE = 'profile/updateProfile'
export const PROFILE_UPDATE_LAST_ACTIVITY = 'profile/updateLastActivity'
export const PROFILE_UPDATE_LAST_ACTIVITY_LOGOUT_TIMER_IDS = 'profile/updateLastActivityTimerIds'
export const PROFILE_SHOW_LAST_ACTIVITY_POPUP = 'profile/showLastActivityPopup'
export const PROFILE_HIDE_LAST_ACTIVITY_POPUP = 'profile/hideLastActivityPopup'
